module.exports = __webpack_public_path__ + "img/serviceState2.da688f5a.svg";